// Core
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type ModalType = {
  activeModal: React.JSX.Element | null;
  showModal: (component: React.JSX.Element) => void;
  showCloseButton: boolean;
  setShowCloseButton: (val: boolean) => void;
  closeModal: () => void;
};

const ModalStore = create(
  devtools<ModalType>((set) => ({
    activeModal: null,
    showCloseButton: true,
    setShowCloseButton: (val: boolean) => set({ showCloseButton: val }),
    showModal: (component: React.JSX.Element) => set({ activeModal: component }),
    closeModal: () => set({ activeModal: null }),
  })),
);

export default ModalStore;
